import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const gatewaysSlice = createSlice({
  name: "gateways",
  initialState,
  reducers: {
    fetchGatewaysStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchGatewaysSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchGatewaysFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchGatewaysStart,
  fetchGatewaysSuccess,
  fetchGatewaysFailure,
} = gatewaysSlice.actions;
export default gatewaysSlice.reducer;
